// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const TwitterIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Twitter/brand"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M22 5.933a8.203 8.203 0 0 1-2.357.648A4.118 4.118 0 0 0 21.445 4.3a8.198 8.198 0 0 1-2.605 1A4.091 4.091 0 0 0 15.845 4c-2.265 0-4.103 1.846-4.103 4.121 0 .324.036.639.107.938a11.624 11.624 0 0 1-8.456-4.307 4.123 4.123 0 0 0-.555 2.071 4.12 4.12 0 0 0 1.826 3.43 4.08 4.08 0 0 1-1.858-.516v.05a4.118 4.118 0 0 0 3.29 4.041 4.139 4.139 0 0 1-1.852.069 4.11 4.11 0 0 0 3.83 2.862 8.206 8.206 0 0 1-5.095 1.766c-.332 0-.657-.021-.979-.057a11.573 11.573 0 0 0 6.29 1.852c7.546 0 11.672-6.28 11.672-11.725 0-.18-.003-.357-.012-.534a8.32 8.32 0 0 0 2.047-2.134l.003.006Z"
}));
export default TwitterIcon;